import { api, ApiError } from "@/api/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useRejectStory() {
  const queryClient = useQueryClient();
  return useMutation<
    {},
    ApiError,
    { episodeId: string; rejectionNotes?: string }
  >({
    mutationKey: ["POST", "story", ":storyId", "reject"],
    mutationFn: (variables) =>
      api.stories.episodeId.reject.post(variables.episodeId, {
        rejectionNotes: variables.rejectionNotes,
      }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["GET", "episodes"],
      });
      queryClient.invalidateQueries({
        queryKey: ["GET", "episodeDetails", variables.episodeId],
      });
      queryClient.invalidateQueries({
        queryKey: ["GET", "submission", "assetsReadyForSubmission"],
      });
      queryClient.invalidateQueries({
        queryKey: ["GET", "validation", "assetsReadyForValidation"],
      });
    },
  });
}
